module.exports = __webpack_public_path__ + "images/fa-cm-title-benefit.webp";